import { Button } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

function Cancel({
  type = "default",
  icon = <CloseOutlined />,
  title = "button.cancel",
  onClick = () => {},
  id = "btn-cancel",
  ...props
}) {
  const { t } = useTranslation();
  const newTitle = title === "button.cancel" ? t(title) : title;
  return (
    <Button icon={icon} type={type} onClick={onClick} id={id} {...props}>
      {newTitle}
    </Button>
  );
}

export default Cancel;
